




























































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PurchaseDeliveryView extends Vue {
  public returnDelivery = Components.ReturnDelivery;
  public items: Common.PurchaseDelivery[] = new Array(0);
  public params: Common.DeliveryQuery = new Common.DeliveryQuery(Common.SalesPurchaseFlags.Purchase);
  public importQuery = new Common.DeliveryImportQuery('入荷',Common.SalesPurchaseFlags.Purchase);
  public exportQuery = new Common.DeliveryExportQuery('入荷',this.params,Common.SalesPurchaseFlags.Purchase);
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'deliveryNo', text: '入荷番号' },
    { value: 'bookDate', text: '仕入日' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'warehouse', text: '入庫倉庫' },
    { value: 'receiver', text: '納入先' },
    { value: 'deliveryDate', text: '入荷日' },
    { value: 'refNo', text: '入荷管理番号' },
    { value: 'projectItem', text: '案件' },      
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true]; //前払・支払情報を非表示
  public tabVisiblesOnInsert: Array<boolean> = [true, true, true, true, true, false, false, false];    
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseCurrency: boolean = false;
  public voucherTypes = Common.voucherTypes;
    public DeliveryFlags = Common.DeliveryFlags;
    
  @Prop() public deliveryNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  
  
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  public get isBarcodeInspection(){
    return (this.$api.tenantSettings.inspectionMode & Common.InspectionModes.receipt) > 0 ;
  }


  // 支払情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('状態', 120),
      new Common.GridItemConfiguration('支払伝票番号', 150),
      new Common.GridItemConfiguration('支払日', 120),
    ],
    3, // 入金日の次を可変表示項目の挿入位置に指定
    'col'
  );
  // ライセンスによって表示の切り替わる項目
  public paymentTabVariableGridItems1: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払通貨', 150),
    new Common.GridItemConfiguration('支払レート', 150)
  ];
  public paymentTabVariableGridItems2: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払金額', 150)
  ];
  public paymentTabVariableGridItems3: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払計上額', 150)
  ];

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    // 一覧表示項目の制御

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 200),
      new Common.GridItemConfiguration('入荷番号', 120),
      new Common.GridItemConfiguration('ワークフロー', 250),      
      new Common.GridItemConfiguration('仕入日', 120),
      new Common.GridItemConfiguration('仕入先', 180),
      new Common.GridItemConfiguration('納入区分', 120),
      // new Common.GridItemConfiguration('入荷予定日', 120),
      new Common.GridItemConfiguration('入荷日', 120),
      new Common.GridItemConfiguration('入庫倉庫', 150),
      new Common.GridItemConfiguration('納入先', 150),        
      new Common.GridItemConfiguration('入荷管理番号', 150),
      new Common.GridItemConfiguration('計上区分', 100),      
      new Common.GridItemConfiguration('取引通貨', 120, this.hasLicenseCurrency),
      new Common.GridItemConfiguration('入荷金額', 120),
      new Common.GridItemConfiguration('税計算区分', 120),
      new Common.GridItemConfiguration('計上レート', 120, this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('案件', 150),          
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      // new Common.GridItemConfiguration('支払締日', 120,false),
      // new Common.GridItemConfiguration('支払予定日', 120,false),
      // new Common.GridItemConfiguration('税抜金額', 120,false),
      // new Common.GridItemConfiguration('消費税額', 120,false),
      // new Common.GridItemConfiguration('税込金額', 120,false),
      // new Common.GridItemConfiguration('買掛金残高', 120,false),      
      // new Common.GridItemConfiguration('計上金額', 120,false),
      // new Common.GridItemConfiguration('計上税額', 120, false),
      // new Common.GridItemConfiguration('税込計上額', 120,false),  
      new Common.GridItemConfiguration('初回保存日', 120),
      new Common.GridItemConfiguration('初回保存者', 120),
      new Common.GridItemConfiguration('最終更新日', 120),
      new Common.GridItemConfiguration('最終更新者', 120),


    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;

    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    // タブ表示の制御
    // this.$set(this.tabVisibles, 6, this.hasLicenseImport); // 前払金適用一覧タブ=>PurchaseInvoiceに移動
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction);
    this.$set(this.tabVisiblesOnInsert, 4, this.$api.useStockFunction);

    // 支払情報タブの表示項目制御
    this.paymentTabVariableGridItems1.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems3.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems2);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems3);
    this.paymentTabGridConfig.setVariableItems(this.paymentTabVariableGridItems1);
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.deliveryNo){
      this.params.deliveryNo = this.deliveryNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.PurchaseDelivery) {
    const workflows = this.$api.formatter.getOptions('workflow_purchaseDelivery');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    obj.bookDate = new Date().getCalendarDate();
    obj.deliveryFlag = this.$api.useStockFunction ? Common.DeliveryFlags.Stock : Common.DeliveryFlags.Services;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //入荷明細タブのリロード
    (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();       
  }

  //仕入伝票へのリンク表示
  public isInvoiceVisible(item: Common.Delivery){
    return item.isTransitPost || item.state == Common.DeliveryStatus.PurchaseDeliveryCompleted;
  }
  // 状態から編集可能か判別する
  public isEditable(state: Common.DeliveryStatus, deliveryFlag:Common.DeliveryFlags, shouldCheckDeliveryFlag:boolean, isDirect:boolean = true, isArrived:boolean = false):boolean{
    
    if(shouldCheckDeliveryFlag && (deliveryFlag == Common.DeliveryFlags.Direct) == isDirect) return false;
    if(state == Common.DeliveryStatus.PurchaseDeliverySaving) return true;
    //if(isArrived && state >= Common.DeliveryStatus.PurchaseDeliverySaving && state <= Common.DeliveryStatus.PurchaseDeliveryPostWaiting) return true;
    return false;
  }
  public isEditable2(item: Common.PurchaseDelivery, isTransitPost: boolean):boolean{
  // 未着品の場合編集不可とする
    if(isTransitPost && item.isTransitPost ) return false;
  }

  // 現金口座の必須・活性を判別する
  public requiredBankAccount(item: Common.Delivery):boolean{
    return item.state == Common.DeliveryStatus.PurchaseDeliverySaving &&  item.settlement == Common.SettlementTypes.ByCash;
  }

  // 仕入先変更時に仕入先の通貨を設定する
  public onChangeSupplier(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    item.onChangeCounterpart();
    this.onChangeBookDate(item, editor);
  }

  // 仕入日変更時に支払締日・支払予定日を設定する
  public onChangeBookDate(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    if(item.counterpart == null || item.bookDate == null) {
        item.closingDate = null;
        item.dueDate = null;
    } else if (item.counterpart.paymentDateType == Common.PaymentDateTypes.Monthly) {
        item.closingDate = item.counterpart.getClosingDate(item.bookDate, this.tenantSettings);
        item.dueDate = item.counterpart.getPaymentDate(item.bookDate, this.tenantSettings);
    } else {
        item.closingDate = item.bookDate;
        item.dueDate = item.counterpart.getPaymentDate(item.bookDate, this.tenantSettings);        
    }

    this.onChangeCurrency(item);
  }

  // 納入先変更時に納入先詳細を設定する
  public onChangeReceiver(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeReceiver();
  }
  // 入庫倉庫変更時に納入先詳細を設定する
  public onChangeWarehouse(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeWarehouse();
  }

  public onChangeDeliveryDate(item: Common.Delivery, editor: Components.Editor)
  {
    if(item.isTransitPost == false)
    {
      item.bookDate = item.deliveryDate;
      this.onChangeBookDate(item,editor);
    }
  }

  // 決済方法が買掛に変更された場合、現金口座をリセットする
  public onChangeSettlement(item: Common.Delivery){
    if(item.settlement != Common.SettlementTypes.ByCash) item.bankAccount = null;
  }

  // 支払日・通貨が変更された場合、計上レートを取得する
  public async onChangeCurrency(item: Common.Delivery){
    const query = new Common.GetExchangeRateQuery();
    query.currency = item.currencyCode;
    query.startDate = item.bookDate;
    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      rate = exchangeRate ? exchangeRate.rate : 1;
      item.exchangeRate = rate;
    });
  }
  public onChangeDeliveryFlag(item: Common.Delivery){
    if(item.deliveryFlag == Common.DeliveryFlags.Services) item.warehouse = null;
  }

  // public async getExchangeRate(currencyCode: string, startDate: Date):Promise<any>{
  //   const query = new Common.GetExchangeRateQuery();
  //   query.currency = currencyCode;
  //   query.startDate = startDate;
  //   let rate = 1;
  //   await this.$api.execute(query).then(res => {
  //     const exchangeRate = res as Common.ExchangeRate;
  //     rate = exchangeRate ? exchangeRate.rate : 1;
  //   });
  //   return rate;
  // }

  // 一覧でチェックされている入荷伝票
  public checkedDeliveries: Array<Common.Delivery>= new Array(0);
  public getCheckedDeliveries(){
    this.checkedDeliveries = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedDeliveries.push(obj);
      }
    });
  }

  // 一覧選択時に明細表示ボタンの非活化状態・入金情報・前払金適用額一覧タブを更新
  public selectedDelivery: Common.Delivery;
  public onSelectedMain(index: number, selected: Common.Delivery) {
    this.selectedDelivery = selected;
  // 一覧選択時に明細表示ボタン、部門の非活化状態確認
    this.checkItemData(selected);

    // 入金情報タブを更新
    this.totalPaymentAmountFC = 0;
    this.totalPendingAmountFC = 0;    
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();

    // 前払金適用額一覧タブを更新
    this.advanceWriteoffamountFC = 0;
    this.advanceJournals = new Array(0);
    if(index >= 0) this.refreshAdvanceList();
  }

  // 支払処理用プロパティ
  public dpSegment: Common.Segment = null;
  public dpPic: string = '';
  public dpCounterpart: Common.Counterpart = null;
  public dpCurrencyCode: string = '';
  public dpPaymentDate: Date = new Date;
  public dpBankAccount: Common.BankAccount = null;
  public dpExchageRate: number = 0;
  public get dpPaymentAmountFC(): number { return this.dpSettlementAmountFC + this.dpCommissionAmountFC; };
  public dpCommissionAmountFC: number = 0;
  public dpCommissionTaxFlag: boolean = false;
  public get dpSettlementAmountFC(): number {
    if(this.checkedDeliveries.length == 0) return 0;
    return this.checkedDeliveries.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };
  public dpMin(delivery:any): number{
    if (delivery.pendingBalanceAmountFC > 0) return 0;
    else return delivery.pendingBalanceAmountFC;
    // if(delivery.paymentBalance == null) return 0;
    // if(delivery.paymentBalance.currentAmountFC > 0) return 0;
    // return delivery.paymentBalance.currentAmountFC;
  }
  public dpMax(delivery:any): number{
    if (delivery.pendingBalanceAmountFC < 0) return 0;
    else return delivery.pendingBalanceAmountFC;    
    // if(delivery.paymentBalance == null) return 0;
    // if(delivery.paymentBalance.currentAmountFC < 0) return 0;
    // return delivery.paymentBalance.currentAmountFC;
  }
  // 入荷日の最小値、未着品計上の場合のみ設定
  public deliveryDateMin(delivery:any): Date{
    if(!delivery.isTransitPost) return null;
    else return delivery.bookDate;
  }


  // 支払処理ダイアログの表示
  public showDeliveryPaymentDialog() {
    this.getCheckedDeliveries();

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveries.length == 0){
      return;
    }
    if(this.checkedDeliveries.filter(delivery=> (delivery.state == Common.DeliveryStatus.PurchaseDeliverySaving)).length > 0){
      this.$api.modal.show('', '入荷伝票が未確定です。', true, null);
      return;
    }
    //if(this.checkedDeliveries.filter(delivery=> (delivery.state & (Common.DeliveryStatus.PurchaseDeliveryPostWaiting | Common.DeliveryStatus.PurchaseDeliveryCompleted)) > 0).length > 0){
    if(this.checkedDeliveries.filter(delivery=> (delivery.state & (Common.DeliveryStatus.PurchaseDeliveryCompleted)) > 0).length > 0){
      this.$api.modal.show('', '支払が完了しています。', true, null);
      return;
    }
    if(this.checkedDeliveries.filter(delivery=> this.checkedDeliveries[0].counterpart.id != delivery.counterpart.id).length > 0){
      this.$api.modal.show('', '仕入先の異なる入荷伝票を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedDeliveries.filter(delivery=> this.checkedDeliveries[0].currencyCode != delivery.currencyCode).length > 0){
      this.$api.modal.show('', '取引通貨の異なる入荷伝票を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedDeliveries.filter(delivery=> this.checkedDeliveries[0].segmentId != delivery.segmentId).length > 0){
      this.$api.modal.show('', '部門の異なる入荷伝票を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    // プロパティの初期化
    this.dpSegment = this.checkedDeliveries[0].segment; //発生部門をセット(非表示)
    this.dpPic = this.$api.auth.userId;        
    this.dpCounterpart = this.checkedDeliveries[0].counterpart;
    this.dpCurrencyCode = this.checkedDeliveries[0].currencyCode;
    this.dpPaymentDate = this.checkedDeliveries.map(delivery => delivery.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.dpBankAccount = null;
    this.dpExchageRate = 1;
    this.dpCommissionAmountFC = 0;
    this.dpCommissionTaxFlag = true; // 販売管理では課税固定
    this.onChangeDpCurrency();

    // ダイアログの表示
    (this.$refs.deliveryPaymentDialog as Components.ListDialog).items = this.checkedDeliveries;
    (this.$refs.deliveryPaymentDialog as Components.ListDialog).showDialog();
  }

  public async onChangeDpCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.dpCurrencyCode;
    query.startDate = this.dpPaymentDate;
    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      rate = exchangeRate ? exchangeRate.rate : 1;
      this.dpExchageRate = rate;
    });
  }

  // 支払処理の実行
  public async submitDeliveryPayment(list: Array<Common.Delivery>) {
    // クエリの設定
    var query = new Common.DeliveryPaymentQuery();
    query.segment = this.dpSegment;
    query.pic = this.dpPic;
    query.counterpart = this.dpCounterpart;
    query.currencyCode = this.dpCurrencyCode;
    query.bankAccount = this.dpBankAccount;
    query.paymentDate = this.dpPaymentDate;
    query.exchangeRate = this.dpExchageRate;
    query.commissionAmountFC = this.dpCommissionAmountFC;
    query.settlementAmountFC = this.dpSettlementAmountFC;
    query.commissionTaxFlag = this.dpCommissionTaxFlag;
    query.deliveries = list;

    // 支払処理の実行
    // this.isLoading = true;
    // await this.$api.execute(query).then(res => {
    //   // this.$router.push('/cash/WithDrawal');
    //   this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',(res as Common.Payment).paymentNo));            
    // })
    // .finally(()=>{
    //   this.isLoading = false;
    // });

    return this.$api.execute(query).then(res => {
      //リストリロード
      (this.$refs.mainList as Components.ListView).reload();
      var payment = res as Common.Payment;
      //支払明細タブのリロード
      this.refreshPaymentList();
      this.$api.modal.show('処理結果','以下の支払伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo))]);
      return true;
    }).catch(()=>{return false;});            
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  checkItemData(delivery:Common.Delivery){
    this.disabledShowItemButton = true;
    
    this.isLoading = true;
    var query = new Common.GetDeliveryItemQuery();
    query.deliveryNo = delivery.deliveryNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = !res.hasItem;
      delivery.hasOrder = res.hasOrder;
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.PurchaseDelivery){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseDelivery, sourceNo : item.deliveryNo},this.$el);
  }
  // 入荷明細一覧を表示
  public showPurchaseDeliveryItem() {
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseDeliveryItem?deliveryNo={0}', this.selectedDelivery.deliveryNo));
    window.open(routeData.href, '_blank');
  }

  // 明細一括入力ボタンの非活性判別
  public disabledAddItemButton(delivery:Common.PurchaseDelivery):boolean{
    return delivery.state != Common.DeliveryStatus.PurchaseDeliverySaving;
  }

  // 返品処理ボタンの非活性判別
  public disabledReturnDeliveryItemFuncButton(delivery:Common.SalesDelivery){
    return delivery.state != Common.DeliveryStatus.PurchaseDeliveryCompleted;
  }

  // 明細一括入力ダイアログ用プロパティ
  public badiCaptions = new Array();
  public badiWidths = new Array();
  public badiSlots = new Array();
  public badiGridConfig:Common.GridConfiguration = null;
  // 明細一括入力ダイアログを表示
  public showBundleAddDeliveryItemDialog() {
    const selectedDelivery = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;    

    if(selectedDelivery.deliveryFlag == Common.DeliveryFlags.Direct) {
      this.$api.modal.show('', '直送の入荷伝票には明細を追加できません。', true, null);
      return;
    }
      // 新規の場合にチェック
    if(selectedDelivery.counterpart == null){
      this.$api.modal.show('', '仕入先を指定してください。', true, null);
      return ;
    }
    // 明細の予備項目表示の可変対応
    this.badiGridConfig = new Common.GridConfiguration([],0,'col');
    this.badiGridConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 250),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 200, this.$api.useStockFunction),
      new Common.GridItemConfiguration('単位', 120),
      new Common.GridItemConfiguration('入荷数量', 130),
      new Common.GridItemConfiguration('単価', 130),
      new Common.GridItemConfiguration('税区分', 120),      
    );
    this.badiGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,false,false,true));

    this.badiCaptions =this.badiGridConfig.gridCaptions;
    this.badiWidths = this.badiGridConfig.gridWidths;
    this.badiSlots = this.badiGridConfig.gridSlots;

    // ダイアログの表示
    var items = new Array();
    var instance = new Common.PurchaseDeliveryItem();
    instance.taxCode = selectedDelivery.counterpart.taxCode;
    items.push(instance);
    (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).items = items;
    (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).showDialog();
  }

  // 商品変更時に商品名・単価・税区分・予備項目を設定する
  public onChangeCommodity(item:Common.PurchaseDeliveryItem, commodity:Common.Commodity){
    item.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(item);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.PurchaseDeliveryItem){
    this.isLoading = true;
    this.$api.execute(new Common.DeliveryGetItemPriceQuery(this.selectedDelivery, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  //行追加時に税区分の初期値を設定
  public async onItemCreate(obj:Common.DeliveryItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
    obj.taxCode = parent.counterpart.taxCode;
    return Promise.resolve(obj);
  }

  public submitBundleAddDeliveryItemRun(){
    const items = (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).items;
    if(items.length > 0) this.submitBundleAddDeliveryItem(items);
  }
  // 明細一括入力の実行
  public async submitBundleAddDeliveryItem(list: Array<Common.DeliveryItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesDelivery;
    var items = new Array();
    for(var obj of list){
      obj.delivery = parent;
      obj.segment = parent.segment;
      obj.warehouse = parent.warehouse;
      items.push(obj);
    }
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddDeliveryItemQuery(Common.SalesPurchaseFlags.Purchase);
    query.deliveryItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/purchase/PurchaseDeliveryItem?deliveryNo={0}', this.selectedDelivery.deliveryNo));
    // });
    return this.$api.execute(query).then(res => {
      //入荷金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res).finally(()=>{
        //入荷明細タブのリロード
        (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();       
        //事後アクションダイアログを表示するためコメントアウト  
        //this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      });
      return true;
    }).catch(()=>{return false;});        
  }

  //明細一括入力ダイアログの予備項目の活性・非活性を切り替える
  public isEditable3(usedType: Common.UsedTypes){
    //商品識別情報,在庫識別情報,入出荷メモは活性。それ以外は非活性
        if(usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.StockAttribute || usedType == Common.UsedTypes.DeliveryMemo)  return true; else return false;
  }  

  // 入金情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPaymentAmount: number = 0;
  public totalPendingAmountFC:number = 0;    
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 支払情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffAmount = 0;
    var totalWriteoffPendingAmountFC = 0;        
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = this.selectedDelivery.deliveryNo;
    query.isSend = true;

    // サーバーから支払情報を取得する
    this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.paymentJournals = res.result;
        this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            totalWriteoffAmount += obj.creditAmount;
            obj.state = Common.PaymentStatus.PaymentCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.PaymentPostWaiting;            
          }
        });
      }
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPaymentAmount = totalWriteoffAmount;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;            
    });
  }

  // 支払一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Withdrawal?paymentNo={0}',paymentNo));
  }
  public onOrderNoClick(orderNo: string){
    this.$router.push(String.format('/purchase/PurchaseOrder?orderNo={0}',orderNo));
  }
  // 前払金適用額一覧タブ更新用プロパティ
  public advanceWriteoffamountFC:number = 0;
  public advanceJournals: Common.TransferJournal[]= new Array(0);

  // 前払金適用額一覧タブを更新
  public refreshAdvanceList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;

    var query = new Common.AdvancePaymentJouralQuery();
    query.delivery = this.selectedDelivery;

    // サーバーから前払金適用額を取得する
    this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.advanceJournals = res.result;
        this.advanceJournals.forEach((obj, index) => {
          totalWriteoffAmountFC += obj.amountFC;
        });
      }
    }).finally(()=>{
      this.isLoading = false;
      this.advanceWriteoffamountFC = totalWriteoffAmountFC;
    });
  }

  // 発注伝票選択一覧ダイアログ用プロパティ
  public apwaCounterpartName: string = '';
  public apwaCounterpart: Common.Counterpart = null;
  // 発注伝票選択一覧ダイアログの表示
  public showAdvancePaymentWriteoffAddDialog() {
    if (this.selectedDelivery != null)
    {
      this.apwaCounterpartName = this.selectedDelivery.counterpart.name;
      this.apwaCounterpart = this.selectedDelivery.counterpart;
      this.isLoading = true;
      this.$api.execute(new Common.AdvanceBalanceQuery(this.selectedDelivery.counterpart.id,0)).then(res => {
        (this.$refs.advancePaymentWriteoffAddDialog as Components.ListDialog).items = (res as Common.LoadResult).result ;
        (this.$refs.advancePaymentWriteoffAddDialog as Components.ListDialog).showDialog();
      })
      .finally(()=>{
        this.isLoading = false;
      });
    }
  }
  // チェックされている発注明細を取得する
  public selectedSalesDeliveryItems(){
    return (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).selectedItems;
  }
  // 返品処理ダイアログの表示
  public showReturnDeliveryDialog(delivery:Common.PurchaseDelivery){
    let componentClass = Vue.extend(this.returnDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          parentDelivery: delivery,
          checkedDeliveryItems: this.selectedSalesDeliveryItems(),
          salesPurchaseFlag: Common.SalesPurchaseFlags.Purchase,
          parentMainList: this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 前払金追加の実行
  public async submitAdvancePaymentWriteoffAdd(list: Array<Common.Order>) {
    // クエリの設定
    var query =new Common.AdvancePaymentWriteoffAddQuery();
    query.delivery = this.selectedDelivery;
    query.orders = list;

    // 前払金追加の実行
    this.isLoading = true;
    await this.$api.execute(query).then(res => {
      // 前払金適用額一覧を更新
      this.refreshAdvanceList();
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  // 前払金削除の実行
  public submitAdvancePaymentWriteoffDelete() {
    // 前払金消込が0件の場合は、何もしない
    var journals:Array<any> = (this.$refs.advanceListBox as Components.Grid).items;
    if(journals.length == 0) return;

    // 選択している前払金消込の取得
    var selectedId = (this.$refs.advanceListBox as Components.Grid).selectedId;
    var journal = journals[selectedId];

    // クエリの設定
    var query = new Common.AdvancePaymentWriteoffDeleteQuery();
    query.transferJournal = journal;

    // 前払金削除の実行
    this.isLoading = true;
    this.$api.execute(query).then(res =>{
      // 前払金適用額一覧を更新
      this.refreshAdvanceList();
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  // 前受金追加・削除ボタン活性制御
  public disabledAdvanceWriteoff():boolean{
    return this.isLoading || this.selectedDelivery.state != Common.DeliveryStatus.PurchaseDeliverySaving;
  }
}
